import React from 'react';

import { Modal, Form, FormGroup, Col, Button, ControlLabel, FormControl } from 'react-bootstrap';
import ImageUploader from 'react-images-upload';
import ModalImage from 'react-modal-image';
import FormData from 'form-data';

import moment from 'moment';
import axios from 'axios';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import './style.scss'; // datepicker style

import constants from '../../../util/constants';

const { API_BASE_URL } = constants;

class ReportArrivalDateModal extends React.Component {
  constructor(props) {
    super(props);

    this.postArrivalDate = this.postArrivalDate.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.getImages = this.getImages.bind(this);
    this.uploadImages = this.uploadImages.bind(this);
    this.showImages = this.showImages.bind(this);
    this.state = {
      selectedDay: null,
      selectedNote: null,
      pictures: [],
      selectedPictures: []
    };
  }

  onDrop(images) {
    this.setState({ selectedPictures: images });
  }

  uploadImages(){
    const { apiToken, selectedRow } = this.props;
    const options = { headers: { 'Authorization': 'Bearer ' + apiToken }};
    const form = new FormData();
    let self = this;

    form.append('LoadingNumber', selectedRow.LOADING_NO);
    let num = 0;
    this.state.selectedPictures.forEach(i=>{
      num++;
      form.append('File' + num, i);
    });

    axios.post(API_BASE_URL + 'Logistics/UploadImage', form, options)
    .then(response => {
      let data = response.data;
      self.imageUploader.clearPictures();
      let pics = [...new Set(self.state.pictures.concat(data))];
      self.setState({
        pictures: pics,
        selectedPictures: []
      });
    })
    .catch(error => {
      let data = error;
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedDay: null,
      selectedNote: null,
      pictures: []
    });
    if(nextProps.selectedRow && nextProps.selectedRow.LOADING_NO)
      this.getImages(nextProps.selectedRow.LOADING_NO);
  }

  getImages(loadingNo){
    const { apiToken } = this.props;
    const options = { headers: { 'Authorization': 'Bearer ' + apiToken }};
    let self = this;
    axios.get(API_BASE_URL + `Logistics/GetImages/?loadingNo=${loadingNo}`, options)
    .then(response => {
      let data = response.data;
      if(data != undefined && data != null){
        self.setState({ pictures: data})
      }
    })
    .catch(error => {
      let data = error;
    });
  }

  postArrivalDate(evt) {
    let { selectedDay } = this.state; 
    const { hideModal, apiToken, selectedRow } = this.props;
    let self = this;

    if(!selectedDay) {
      selectedDay = selectedRow ? moment(selectedRow.REPORTED_ARRIVAL_DATE) : null;
    }

    if(selectedDay) {

      if(this.state.pictures){
        this.uploadImages();
      }

      const options = { headers: { 'Authorization': 'Bearer ' + apiToken }};
      const note = this.noteInput.value || '';

      const form = new FormData();
      form.append('LoadingNumber', selectedRow.LOADING_NO);
      form.append('ArrivalTime', selectedDay.format('YYYY-MM-DD'));
      form.append('Note', note);

      axios.post(API_BASE_URL + 'Logistics/ReportArrival', form, options)
      .then(response => {
        hideModal(true);
        this.props.reloadData();
      })
      .catch(error => {
        let data = error;
      });
    }
  }

  showImages(){
    let images = [];
    this.state.pictures.forEach(p=>{ 
      images.push(<ModalImage
        small={`data:image/png;base64,${p}`}
        large={`data:image/png;base64,${p}`}
      />)
    })
    return images;
  }

  render() {
    const { selectedRow } = this.props;
    const showModal = this.props.showModal || false;

    const selectedLoadingNo = selectedRow ? selectedRow.LOADING_NO : '';
    const selectedDay = selectedRow ? (selectedRow.REPORTED_ARRIVAL_DATE ? moment(selectedRow.REPORTED_ARRIVAL_DATE).format('YYYY-MM-DD') : null) : null;
    const selectedNote = selectedRow ? selectedRow.REPORTED_NOTE : '';

    return (
      <Modal show={showModal} onHide={() => { this.props.hideModal(false) }}>
        <Modal.Header closeButton> 
          <Modal.Title>Report arrival date for: {selectedLoadingNo}</Modal.Title>
        </Modal.Header>
        
        <Modal.Body>
          <Form horizontal autoComplete="off" onSubmit={evt => { evt.preventDefault(); this.postArrivalDate() }}>
            <FormGroup controlId="formHorizontalArrivalDate">
              <Col componentClass={ControlLabel} sm={3}>Arrival date</Col>
              <Col sm={9}>
                <DayPickerInput className="form-control"
                                dayPickerProps={{ firstDayOfWeek: 1 }}
                                value={selectedDay}
                                name="arrivalDate" placeholder="YYYY-MM-DD"
                                format="YYYY-MM-DD"
                                onDayChange={(selectedDay) => { this.setState({ selectedDay }) }} />
              </Col>
            </FormGroup>
            <FormGroup controlId="formHorizontalImage">
              <Col componentClass={ControlLabel} sm={3}>Images</Col>
              <Col sm={9}>
                <ImageUploader
                  withIcon={false}
                  buttonText='Choose images'
                  onChange={this.onDrop}
                  imgExtension={['.jpg', '.jpeg', '.gif', '.png']}
                  maxFileSize={5242880}
                  withPreview={true}
                  ref={iu => this.imageUploader = iu}
                />
               <span className="pull-right flex imgContainer">{this.showImages()}</span>
            
              </Col>
              
              
           </FormGroup>
            <FormGroup controlId="formHorizontalNotice">
              <Col componentClass={ControlLabel} sm={3}>
                Note
              </Col>
              <Col sm={9}>
                <FormControl componentClass="textarea" placeholder="Note" value={this.state.selectedNote ? this.state.selectedNote : selectedNote } onChange={evt => { this.setState({ selectedNote: evt.target.value }) }} inputRef={input => this.noteInput = input} />
              </Col>
            </FormGroup>
          </Form>
       
        </Modal.Body>
        <Modal.Footer>
          <FormGroup>
            <Col smOffset={2} sm={10}>
              <Button type="button" bsStyle="primary" onClick={() => {this.uploadImages(); }} >Upload images</Button>
              <Button type="button" bsStyle="primary" onClick={this.postArrivalDate}>Report arrival date</Button>
            </Col>
          </FormGroup>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ReportArrivalDateModal;